import { useContext, useEffect, useRef, useState } from "react";

import {
  useLocalVideo,
  useMeetingStatus,
} from "amazon-chime-sdk-component-library-react";

import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";

import {
  ChimeMessageContext,
  MeetingInfoContext,
} from "../../../../../context";

import RealWareButton from "./realware-button";

interface CameraProps {
  startWithVideo: boolean;
  disabled?: boolean;
}

const CameraButton: React.FC<CameraProps> = ({
  startWithVideo,
  disabled = false,
}) => {
  const { isVideoEnabled, toggleVideo } = useLocalVideo();
  const status = useMeetingStatus();

  const { userId } = useContext(MeetingInfoContext);
  const { subscribeToChannel, sendMessage } = useContext(ChimeMessageContext);
  const [subscribed, setSubscribed] = useState<boolean>(false);

  const [isWaiting, setIsWaiting] = useState<boolean>(false);

  const [expectedState, setExpectedState] = useState<boolean>(startWithVideo);
  const expectedStateRef = useRef<boolean>(startWithVideo);

  const onCameraButton = (active: boolean) => {
    expectedStateRef.current = active;
    setExpectedState(active);
  };

  const sendStartMessage = () => {
    sendMessage("camera", expectedStateRef.current ? "true" : "false", userId);
  };

  useEffect(() => {
    expectedStateRef.current = expectedState;
  }, [expectedState]);

  useEffect(() => {
    if (subscribed) {
      return;
    }

    if (status != 1) {
      return;
    }

    subscribeToChannel("camera", "labelled-camera-button", (message) => {
      if (message.payload == "join") {
        sendStartMessage();
        return;
      }

      const nextState = message.payload == "true";
      expectedStateRef.current = nextState;
      setExpectedState(nextState);
    });

    sendMessage("camera", isVideoEnabled ? "false" : "true", userId);
    setSubscribed(true);
  }, [
    status,
    subscribed,
    subscribeToChannel,
    sendMessage,
    isVideoEnabled,
    userId,
  ]);

  // handles starting with video
  useEffect(() => {
    const waitThenToggleVideo = async () => {
      // Ensure that a toggle calls is not made if before the button is finished waiting
      await toggleVideo();

      if (subscribed) {
        sendMessage("camera", isVideoEnabled ? "false" : "true", userId);
      }

      setIsWaiting(false);
    };

    console.log("~~ivai set expected state");
    if (status != 1) {
      return;
    }

    if (expectedStateRef.current == isVideoEnabled) {
      return;
    }

    if (isWaiting) {
      return;
    }

    setIsWaiting(true);
    waitThenToggleVideo();
  }, [expectedStateRef, expectedStateRef.current, status]);

  return (
    <RealWareButton
      disabled={disabled}
      activeIcon={<VideocamIcon color="action" />}
      inactiveIcon={<VideocamOffIcon color="action" />}
      active={isVideoEnabled}
      onClick={onCameraButton}
      activeLabel={"Disable Camera"}
      inactiveLabel={"Enable Camera"}
      showText={true}
    />
  );
};

export default CameraButton;
